module.exports = __webpack_public_path__ + "img/Group 5336.542cbf89.png";